import React, { useCallback } from 'react';
import { selectCanvasRect } from '~/dashboard/views/workflows/store/redux/selectors';
import { useAppSelector } from '~/store/reduxHooks';
import { StyledIslandDrawer, StyledIslandDrawerContent, StyledIslandItemContainer } from './styles';
import { COMPLEX_ISLAND_WIDTH } from '~/dashboard/views/workflows/service/graph';
import { useAnimationTrigger } from 'flow/editor/hooks';


interface BaseComplexIslandProps {
  children: React.ReactNode;
  onDrawerToggle: () => void;
  title: string;
}

export default function BaseComplexIsland({
  children,
  onDrawerToggle,
  title,
}: BaseComplexIslandProps) {
  const { height: canvasHeight } = useAppSelector(selectCanvasRect);

  const [show, setShow] = useAnimationTrigger();

  const handleDrawerToggle = useCallback(() => {
    setShow(false);
    onDrawerToggle();
  }, [onDrawerToggle, setShow]);

  return (
    <StyledIslandDrawer
      canvasHeight={canvasHeight}
      placement="right"
      show={show}
      title={title}
      toggleDrawer={handleDrawerToggle}
      testIdForCloseBtn="closeIslandButton"
      defaultSize={COMPLEX_ISLAND_WIDTH}
    >
      <StyledIslandDrawerContent>
        <StyledIslandItemContainer>
          {children}
        </StyledIslandItemContainer>
      </StyledIslandDrawerContent>
    </StyledIslandDrawer>
  );
}
